import { useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { ROUTES } from 'constants/RoutePaths';

const RequireAuth = ({ allowedRoles }) => {
  const location = useLocation();
  const { roles, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  const content = roles.some((role) => allowedRoles.includes(role)) ? (
    <Outlet />
  ) : (
    <Navigate to={`/${ROUTES.LOGIN}`} state={{ from: location }} replace />
  );

  return content;
};
export default RequireAuth;
